let editMode = false;
const selectedTickets = new Set();

export const getTelegramEditMode = () => editMode;
export const getSelectedTickets = () => [...selectedTickets];

export const setTelegramEditMode = (val) => {
  editMode = val;
  if (!val) selectedTickets.clear();
  window.dispatchEvent(new CustomEvent("telegram-edit-mode", { detail: { editMode: val, selected: [] } }));
};

export const toggleTicketSelection = (ticketId) => {
  if (selectedTickets.has(ticketId)) {
    selectedTickets.delete(ticketId);
  } else {
    selectedTickets.add(ticketId);
  }
  window.dispatchEvent(new CustomEvent("telegram-selection", { detail: { selected: [...selectedTickets] } }));
};

export const isTicketSelected = (ticketId) => selectedTickets.has(ticketId);
